/**
 * Collapsible component that displays a header and either a row of key/value data
 * from the infoItems prop or custom children components.
 * See the Discovery Inventory Drawer for usage example.
 */
import React from 'react';
import { Collapse } from '../../components';
import { InfoRow } from '../../components';
import classNames from 'classnames';

import './BasicInfoCollapse.scss';

export const BasicInfoCollapse = ({ title, infoItems = [], greyHeader = false, children }) => {
    const headerClass = classNames({ 'ant-collapse-header-grey': greyHeader });

    const panelContent =
        children ||
        infoItems?.map((item, index) => (
            <InfoRow
                key={index}
                label={item.label}
                value={item.value}
                copyable={item.copyable}
                tooltipThreshold={item.tooltipThreshold}
            />
        ));

    const items = [
        {
            key: '1',
            label: title,
            className: headerClass,
            children: panelContent,
        },
    ];

    return <Collapse className="basic-info-collapse" defaultActiveKey={['1']} accordion items={items} />;
};
